module.exports = __webpack_public_path__ + "static/media/dotnet.b2ebf6aa.png";